import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'

const styles = theme => ({
  listItemSecondaryAction: {
    position: 'static',
    transform: 'none',
    width: 162,
    whiteSpace: 'nowrap',
  },
})

const ListItemSecondaryActionExtraMargin = ({ classes, ...other }) => (
  <ListItemSecondaryAction
    className={classes.listItemSecondaryAction}
    {...other}
  />
)

export default withStyles(styles)(ListItemSecondaryActionExtraMargin)



// WEBPACK FOOTER //
// ./src/components/common/ListItemSecondaryActionExtraMargin.js